import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import { ModalDismissReasons, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { PaginationInstance } from "ngx-pagination";
import { Subject } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { SocialTemplate } from "../interface/social";
import { TemplatesService } from "../templates.service";
@Component({
  selector: "app-templates-section",
  templateUrl: "./templates-section.component.html",
  styleUrls: ["./templates-section.component.scss"],
})
export class TemplatesSectionComponent implements OnInit {
  @ViewChild("templateModal", { static: true })
  templateModal: ElementRef;
  @Input() isSettings: boolean;
  @Input() isMainPage: boolean;
  @Input() isZceppaTemplateSection: boolean;
  @Input() hideDelete: boolean = false;
  @Input("hideContent") hideContent: boolean = false;
  @Input() defaultTemplate: string[] | null = [];
  @Input() isHighlightDefaultTemplate: any = null;

  @Input() feature:
    | "social"
    | "messaging"
    | "reply"
    | "appointment"
    | "mystore"
    | "interact";
  @Input() isTemplateModal: boolean;
  @Input() isInteractRhs: boolean = false;
  @Output() public onTemplateSelect: EventEmitter<SocialTemplate> =
    new EventEmitter<SocialTemplate>();
  @Output() public onDeleteTemplate: EventEmitter<string> =
    new EventEmitter<string>();
  @Output() public updatedSearchText: EventEmitter<string> =
    new EventEmitter<string>();

  private _templates = [];
  templatesInPage: any[];
  templatesArrayInModal: any[];
  @Input() isNotMultiOutlet: boolean = true;
  // @Input() templates: any[] = [];
  @Input("templates")
  set templates(value) {
    this._templates = value ?? [];
  }
  get templates() {
    return this._templates;
  }
  isDefaultTemplate(template: any) {
    let defaultTemplate = this.defaultTemplate?.some(
      (eachTemplate) => eachTemplate == template?.id
    );
    return defaultTemplate || false;
  }
  private _selectedTemplate: SocialTemplate = null;
  @Input()
  set selectedTemplate(value) {
    this._selectedTemplate = value;
  }
  get selectedTemplate() {
    return this._selectedTemplate;
  }
  paginationConfig: PaginationInstance;
  closeResult: string;
  searchText: string = "";
  selectedTemplateArray: any[] = [];

  searchUpdate = new Subject<string>();
  constructor(
    private modalService: NgbModal,
    private cdRef: ChangeDetectorRef,
    private templatesService: TemplatesService,
    private router: Router
  ) {}

  highlightDefaultTemplate() {
    let isHighlightDefaultTemplate =
      this.isHighlightDefaultTemplate == this.selectedTemplate?.id;
    if (isHighlightDefaultTemplate) {
      this.moveSelectedTemplate(true);
    }
  }

  ngOnInit() {
    this.init();
    this.moveSelectedTemplate();
    setTimeout(() => {
      this.highlightDefaultTemplate();
    }, 100);
    this.templatesService.resetFields$.subscribe((isReset) => {
      if (isReset) {
        this.resetFields();
      }
    });
    this.templatesService.updateTemplatesArrPagination$.subscribe(
      (response) => {
        if (response !== null) {
          this.paginationConfig.totalItems = response || 0;
        }
      }
    );

    this.searchUpdate.pipe(debounceTime(300)).subscribe((value) => {
      this.updatedSearchText.emit(this.searchText);
    });
  }

  init() {
    this.templatesArrayInModal = this.templates;
    this.paginationConfig = {
      id: "templates",
      itemsPerPage: 10,
      currentPage: 1,
      totalItems: this.templates?.length,
    };
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.templates && changes.templates.currentValue !== undefined) {
      let templates = changes.templates.currentValue;
      this.templates = templates;
      this.templatesInPage = this.templates;
      this.init();
    }
  }
  ngOnDestroy() {
    this.onTemplateSelect.unsubscribe();
  }

  getCurrentPage() {
    return this.paginationConfig?.currentPage;
  }

  onSelectTemplate(template: SocialTemplate) {
    this.selectedTemplate = template;
    this.onTemplateSelect.emit(template);
  }

  onDeleteTemplateAction(templateID: string) {
    this.onDeleteTemplate.emit(templateID);
  }
  moveSelectedTemplate(isFromModal?: boolean) {
    if (isFromModal) {
      let templateArray = this.selectedTemplate
        ? [{ ...this.selectedTemplate }, ...this.filteredArrayOfTemplates()]
        : [...this.filteredArrayOfTemplates()];
      this.templatesInPage = templateArray;
    } else {
      this.templatesInPage = this.templates;
    }
  }

  // templatesInPageGetter() {
  //   return ...this.templatesInPage
  // }

  filteredArrayOfTemplates() {
    const filteredArrayOfTemplates = this.templates.filter(
      (template) => template?.id !== this.selectedTemplate?.id
    );
    return filteredArrayOfTemplates;
  }
  // Used in HTML
  filterRecentTemplates(templates?: any[]) {
    const filterRecentTemplates =
      (templates ? templates : this.templatesArrayInModal).filter(
        (template) => template?.is_recently_used
      ) || [];
    return [...filterRecentTemplates];
  }
  lastIndex() {
    const filterRecentTemplates =
      this.templatesArrayInModal.filter(
        (template) => template?.is_recently_used
      ) || [];
    return [...filterRecentTemplates].length;
  }
  filterRemainingTemplates() {
    const filterRemainingTemplates =
      this.templates.filter((template) => !template?.is_recently_used) || [];
    return [...filterRemainingTemplates];
  }
  closeModal() {
    this.isTemplateModal = false;
    this.modalService.dismissAll();
  }
  resetFields() {
    this.searchText = "";
  }

  redirectToMessaging() {
    this.router.navigate(["/settings/messaging-template"]);
  }

  openModal(modal: any) {
    this.isTemplateModal = true;
    this.modalService
      .open(modal, {
        backdropClass: "light-blue-backdrop",
        size: "lg",
        backdrop: "static",
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  /**
   * Close modal popup
   *
   * @private
   * @param {*} reason
   * @returns {string}
   */
  private getDismissReason(reason: any): string {
    this.isTemplateModal = false;
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  getHeight(perfectScrollBar) {
    if (perfectScrollBar) {
      const y =
        perfectScrollBar?.directiveRef?.elementRef?.nativeElement?.getBoundingClientRect()
          ?.y || 0;
      const height = window.innerHeight || 0;
      return `${height - y - 40}px`;
    } else {
      return "250px";
    }
  }

  isReviewTemplateType(template: any) {
    let isReviewComponent = template?.is_review_share_template === true;
    return isReviewComponent ? true : false;
  }
}
